
import { Routes } from "@angular/router";
import { ChangePasswordComponent } from "../../website/auth/login/change-password/change-password.component";

export const portalContent: Routes = [
    {
        path: 'portal',
        loadChildren: () => import('../../portal/portal.routes'),
    },
    {
        path: 'change-password',
        component: ChangePasswordComponent
    }
]

